import { useEffect, useMemo } from "react";

import { useBoards } from "../../reactQuery/boards";
import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import {
  getBoardKeyFromNumericId,
  isNumericBoardId,
} from "../../utils/boardUtils";
import { getLegacyBoardRedirectPath } from "../utils/routeUtils";

export function useBoardUrlRedirect({ id, navigate }) {
  const [cardId] = useCustomSearchParams("card_id");
  const { isLoading, boards, isError } = useBoards();

  const redirectPath = useMemo(() => {
    if (isLoading || isError || !boards || !isNumericBoardId(id)) {
      return null;
    }

    const responseData = boards?.data?.data?.responseData;
    const boardKey = getBoardKeyFromNumericId(responseData, id);

    return getLegacyBoardRedirectPath({ boardKey, cardId });
  }, [boards, cardId, id, isError, isLoading]);

  useEffect(() => {
    if (redirectPath) {
      navigate(redirectPath, { replace: true });
    }
  }, [navigate, redirectPath]);

  return {
    isLoading,
    isError,
    redirectPath,
  };
}
